export default __webpack_public_path__ + "static/media/pause_recommend.df8cc406.png";